import {
  Dispatch,
  SetStateAction,
  createContext,
  useEffect,
  useState,
} from "react";

import { Congress } from "@/client";

type CongressContextState = {
  congress: Congress;
  setCongress: Dispatch<SetStateAction<Congress>>;
};

const defaultState: CongressContextState = {
  // @ts-expect-error initial context state
  congress: null,
  // eslint-disable-next-line @typescript-eslint/no-empty-function
  setCongress: () => {},
};

const CongressContext = createContext<CongressContextState>(defaultState);

function CongressProvider({ children }: { children: React.ReactNode }) {
  const [congress, setCongress] = useState<Congress>(() => {
    const savedCongress = localStorage.getItem("congress");
    return savedCongress ? JSON.parse(savedCongress) : null;
  });

  useEffect(() => {
    if (congress) {
      localStorage.setItem("congress", JSON.stringify(congress));
    } else {
      localStorage.removeItem("congress");
    }
  }, [congress]);

  return (
    <CongressContext.Provider value={{ congress, setCongress }}>
      {children}
    </CongressContext.Provider>
  );
}

export { CongressContext, CongressProvider };
